(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Tooltips
  tippy('.tippy-button', {
    content: function (reference) {
      var id = reference.getAttribute('data-template');
      var template = document.getElementById(id)
      return template.innerHTML;
    },
    allowHTML: true,
    maxWidth: 200,
    trigger: 'click',
    onShow: function (instance) {
      instance.reference.classList.add('active');
    },
    onHide: function (instance) {
      instance.reference.classList.remove('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(function ($) {
    "use strict";

    $('.image-text-slider').slick({
      adaptiveHeight: true,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gstam-template"]) return;
  try {
    
  jQuery(function ($) {
    "use strict";

    $('.product-single__slider').slick({
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="far fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="far fa-angle-right"></i></button>',
    });

    $('.product-single__highlights-slider').slick({
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  jQuery(function ($) {
    "use strict";

    $('.product-single__slider').slick({
      dots: true,
      prevArrow: '<button type="button" aria-label="Previous product image" aria-controls="product-single__slider" class="slick-prev"><i class="far fa-angle-left"></i></button>',
      nextArrow: '<button type="button" aria-label="Next product image" aria-controls="product-single__slider" class="slick-next"><i class="far fa-angle-right"></i></button>',
    });

    $('.product-single__highlights-slider').slick({
      prevArrow: '<button type="button" aria-label="Previous slide" aria-controls="product-single__highlights-slider" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow: '<button type="button" aria-label="Next slide" aria-controls="product-single__highlights-slider" class="slick-next"><i class="fas fa-angle-right"></i></button>',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  jQuery(function ($) {
    "use strict";

    $('.reviews-slider').slick({
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speedhack-slider"]) return;
  try {
    
  jQuery(function ($) {
    "use strict";

    $('.speedhack-template-slider .slider').slick({
      adaptiveHeight: true,
      fade: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
